module.exports = __webpack_public_path__ + "static/media/empty.7f900a6e.webp";